<div class="container p-3">
    <div class="row">
        <div class="col">
            <div class="text-center" *ngIf="user">
                <span class="d-block">
                    Logged in as
                    <a href="mailto:{{ user.email }}">
                        <!--i class="fas fa-user"></i--> "{{ user.firstName }} {{ user.lastName }}" &lt;{{ user.email }}&gt;
                    </a>
                </span>
                <code class="d-none text-start"><pre *ngIf="value">{{ value }}</pre></code>
            </div>
        </div>
    </div>
</div>